import { generateUuidV4Regex } from "@/common/helpers/utils";
import { NotFoundView } from "@/views/common/notfound.view";
import { VehicleValuationDetailView } from "@/views/vehicle-valuation-detail/vehicle-valuation-detail.view";
import { Route, Switch } from "wouter";
import { ConfirmView } from "./confirm/confirm.view";
import { CreateView } from "./create/create.view";
import { VehicleValuationInitializeRoutes } from "./initialize/vehicle-valuation-initialize.routes";
import { VehicleValuationSelectDatVehicleView } from "./select/vehicle-valuation-select-dat-vehicle.view";
import { VehicleValuationView } from "./vehicle-valuation.view";

export function VehicleValuationRoutes() {
  const vehicleValuationUuidRegex = generateUuidV4Regex({
    paramName: "uuid",
  });
  const vehicleValuationConfirmUuidRegex = generateUuidV4Regex({
    paramName: "uuid",
    suffix: "/confirm",
  });
  const vehicleValuationSelectVehicleUuidRegex = generateUuidV4Regex({
    paramName: "uuid",
    suffix: "/select-vehicle",
  });

  return (
    <Switch>
      <Route nest path="/initialize" component={VehicleValuationInitializeRoutes} />
      <Route path="/create" component={CreateView} />
      <Route path={vehicleValuationConfirmUuidRegex} component={ConfirmView} />
      <Route path={vehicleValuationSelectVehicleUuidRegex} component={VehicleValuationSelectDatVehicleView} />
      <Route path={vehicleValuationUuidRegex} component={VehicleValuationDetailView} />
      <Route path="/" component={VehicleValuationView} />
      <Route component={NotFoundView} />
    </Switch>
  );
}
